import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCountry,
  getParticularPage,
  getNext,
  getPrevious,
  createCountry,
  updateCountry,
  handleSearch,
  getCountryById,
} from "./thunk";

const initialState = {
  countries: [],
  edit: false,
  country: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCountry: false,
  loadingNext: false,
  showCreateModal: false,
};

export const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllCountry: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCountry = false;
      state.country = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCountry.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCountry.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCountry.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getCountryById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCountryById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.country = action.payload.data;
    });
    builder.addCase(getCountryById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.country = null;
    });
    builder.addCase(updateCountry.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCountry.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCountry.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCountry.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCountry = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCountry.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCountry = false;
        state.countries = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCountry.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCountry = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllCountry } = countrySlice.actions;

export default countrySlice.reducer;
